"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Table = _interopRequireDefault(require("@mui/material/Table"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 発見事項分類ヘッダ
 */
const CountTable = (0, _styles.styled)(_Table.default)({
  height: '100% !important',
  width: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'collapse'
});
const JigyoCell = (0, _styles.styled)(_TableCell.default)({
  width: '40%'
});
const LeftBorderCell = (0, _styles.styled)(_TableCell.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border && theme.palette.border.white
  };
});
const TopBorderRow = (0, _styles.styled)(_TableRow.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.border && theme.palette.border.white
  };
});
const CellWidthCell = (0, _styles.styled)(_TableCell.default)({
  paddingRight: 8,
  width: '15%'
});
const LeftBorderCellWidth = (0, _styles.styled)(_TableCell.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    borderLeft: 'solid 1px',
    borderLeftColor: theme.palette.border && theme.palette.border.white,
    paddingRight: 8,
    width: '15%'
  };
});
const CountsHeader = props => {
  const {
    intl
  } = props;
  return /*#__PURE__*/_react.default.createElement(CountTable, null, /*#__PURE__*/_react.default.createElement("colgroup", null, /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '40%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  }), /*#__PURE__*/_react.default.createElement("col", {
    style: {
      width: '15%'
    }
  })), /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(JigyoCell, {
    rowSpan: 3,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    align: "center",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_TGT_JIGYO_NM
  }))), /*#__PURE__*/_react.default.createElement(LeftBorderCell, {
    colSpan: 4,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HAKKEN_JIKO_BUNRUI
  })))), /*#__PURE__*/_react.default.createElement(TopBorderRow, null, /*#__PURE__*/_react.default.createElement(LeftBorderCell, {
    colSpan: 2,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_GRP_FUTEKIGO
  }))), /*#__PURE__*/_react.default.createElement(LeftBorderCell, {
    colSpan: 2,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_GRP_KAIZEN
  })))), /*#__PURE__*/_react.default.createElement(TopBorderRow, null, /*#__PURE__*/_react.default.createElement(LeftBorderCellWidth, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_JUDAI
  }))), /*#__PURE__*/_react.default.createElement(CellWidthCell, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_KEIBI
  }))), /*#__PURE__*/_react.default.createElement(LeftBorderCellWidth, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_KANSATSU
  }))), /*#__PURE__*/_react.default.createElement(CellWidthCell, {
    align: "right"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "text.secondary",
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_HKN_BNR_SUISHO
  }))))));
};
var _default = exports.default = (0, _reactIntl.injectIntl)(CountsHeader);